<template><!-- svgo-optimised -->
<svg class="icon icon__plus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.982 4.5a.5.5 0 0 1 .5.5v6.5H19a.5.5 0 0 1 0 1h-6.518V19a.5.5 0 0 1-1 0v-6.5H5a.5.5 0 0 1 0-1h6.482V5a.5.5 0 0 1 .5-.5" fill-rule="evenodd" clip-rule="evenodd"/></svg>
</template>